namespace Matrix.Rebalancer {
    export interface SummaryViewFormatRow {
        ViewCode?: string;
        SortOrder?: number;
        Expression?: string;
        RowName?: string;
        ColumnName?: string;
        MeasureName?: string;
        FormatName?: string;
        BackColour?: string;
        ForeColour?: string;
        FontSize?: number;
        FontBold?: boolean;
        FontItalic?: boolean;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        ViewName?: string;
        ViewRowId?: number;
    }

    export namespace SummaryViewFormatRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'ViewCode';
        export const localTextPrefix = 'Rebalancer.SummaryViewFormat';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            ViewCode = "ViewCode",
            SortOrder = "SortOrder",
            Expression = "Expression",
            RowName = "RowName",
            ColumnName = "ColumnName",
            MeasureName = "MeasureName",
            FormatName = "FormatName",
            BackColour = "BackColour",
            ForeColour = "ForeColour",
            FontSize = "FontSize",
            FontBold = "FontBold",
            FontItalic = "FontItalic",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            ViewName = "ViewName",
            ViewRowId = "ViewRowId"
        }
    }
}
